export const MeasurementStrategy = {
  centerToCenter: 'center-to-center',
  edgeToEdge: 'edge-to-edge',
  centerToCenterNormalized: 'center-to-center-normalized',
};
